import React, { Suspense, lazy } from 'react';
import Loader from './loader';

const TabSettings = lazy(() => import('./index'));

function TabSettingsLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <TabSettings {...props} />
        </Suspense>
    );
}

export default TabSettingsLazy;
export { TabSettingsLazy };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-settings/lazy.js